import React, { useEffect } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import Brands1 from "../brands/Brands1";
import Clientspeak from "../testimonials/Clientspeak";
import { FaArrowRight } from "react-icons/fa";
import { FaLongArrowAltRight, FaPlay } from "react-icons/fa";
import "aos/dist/aos.css";
import AOS from "aos";

const Publishing = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      {/* Breadcrumbs */}
      <BreadcrumbsHeader
        title="Publishing"
        backgroundImage="/images/breadcrumbs/publishing.jpeg"
      />

      {/* Intro Section */}
      <section className="section-about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <div className="b-mod-heading text-center">
                <p className="first-heading font-secondary wow fadeInDown">
                  Robust &amp; Reliable Tech and Digital Marketing Solutions for
                </p>
                <h2 className="heading-line line-right customColor customPseudoElBg wow fadeIn">
                  <strong>Publishing Industry</strong>
                </h2>
                <p className="second-heading font-additional">
                  Technology &amp; digital marketing has become a vital aspect
                  of book publication houses. Be it automation, publishing house
                  management, or targeting &amp; managing the right audience,
                  marketing books to their respective readers – everything is
                  possible via technology &amp; digital solutions.
                  <br />
                  Serving as a technology &amp; digital partner of eminent book
                  publishing houses, authors, and publishing professionals, we
                  bring years of rich experience in delivering cutting-edge
                  software applications, mobile apps, and digital solutions
                  &amp; services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Offerings Section */}
      <section className="section-about">
        <div className="container-bg-additional relative clearfix">
          <div className="b-services-bg-filter customBgColor"></div>
          <div className="b-featured-services">
            <div className="container">
              <div className="row">
                {/* Left Content */}
                <div className="col-xs-12 col-sm-7 col-md-6 col-lg-7">
                  <div className="featured-services-left wow slideInLeft">
                    <div className="b-f-s-info offer">
                      <h3 className="f-s-title">
                        Our Offerings For <br />
                        Publication Houses &amp; Authors
                      </h3>
                      <p>
                        We offer a wide range of web, cloud, and digital
                        marketing solutions &amp; services for book publication
                        houses, authors, and other publishing entities.
                      </p>
                      <a
                        href="/contact"
                        className="btn btn-default-arrow btn-sm"
                      >
                        <FaArrowRight /> get in touch
                      </a>
                    </div>
                  </div>
                </div>

                {/* Right Content */}
                <div className="col-xs-11 col-sm-5 col-md-5 col-lg-5">
                  <div className="bank featured-services-right wow fadeIn">
                    <div className="b-work-steps">
                      {[
                        {
                          title: "Application Services",
                          text: "Designing cloud-based web applications for publishers and industry entities.",
                        },
                        {
                          title: "Mobility Services",
                          text: "Helping publishers grow smart with official mobile apps for books and internal workflows.",
                        },
                        {
                          title: "Cloud Infrastructure Services",
                          text: "Providing & managing end-to-end cloud infra for web & mobile apps.",
                        },
                        {
                          title: "Business Process Services",
                          text: "Managing overall customer relationship & support processes.",
                        },
                        {
                          title: "Digitalisation & Technology Automation",
                          text: "Overall digitisation of publishing and upliftment via tech automation.",
                        },
                      ].map((item, index) => (
                        <div className="b-services-item" key={index}>
                          <div className="services-icon">
                            <div className="circle-0">
                              <div className="circle-1">
                                <div className="circle-2"></div>
                              </div>
                            </div>
                          </div>
                          <div className="services-text">
                            <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                              <span className="customColor">{index + 1}.</span>{" "}
                              {item.title}
                            </h6>
                            <p>{item.text}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* End Right */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose ISOLS */}
      <section className="section-about">
        <div className="container">
          <div className="b-home-video-block">
            <div className="container-fluid">
              {/* Left Side (Video) */}
              <div className="col-xs-12 col-sm-5 col-md-6 col-lg-6 left-side wow slideInLeft">
                <div className="b-video-holder">
                  <a
                    className="video-image playVideo"
                    href="https://www.youtube.com/watch?v=eq3jsESwuzQ&feature=youtu.be"
                    data-toggle="lightbox"
                    data-title="Why Choose ISOLS Group"
                  >
                    <FaPlay className="demo-icon play-icon" />
                    <span className="video-title">play the video</span>
                  </a>
                </div>
              </div>

              {/* Right Side (Content) */}
              <div className="col-xs-12 col-sm-7 col-md-6 col-lg-6 right-side wow slideInRight">
                <div className="content">
                  <div className="b-mod-heading">
                    <p className="first-heading customPseudoElBg font-secondary">
                      Why Choose
                    </p>
                    <h2 className="heading-line line-right">
                      <strong>ISOLS?</strong>
                    </h2>
                    <div className="b-text">
                      <p>
                        Designing &amp; implementing industry-specific
                        technology and digital solutions for automation &amp;
                        business enhancement is our forte, and we do it
                        passionately. Our solutions are backed by research,
                        industry insights, and pilot implementations.
                      </p>
                    </div>
                    <a
                      href="/about-isolsgroup"
                      className="btn btn-default-arrow"
                    >
                      <FaArrowRight /> know more about ISOLS Group
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <Clientspeak />

      {/* Brands */}
      <Brands1 />
    </div>
  );
};

export default Publishing;
